import { FC } from 'react';
import { Navigate } from 'react-router-dom';
import withMe, { MePropsType } from '../../hocs/withMe.tsx';
import { UserRoles } from '../../constants/entities.ts';
import { Children } from '../../constants/types/prop.types.ts';
import Routes from '../routes.enum.ts';

type Props = MePropsType &
  Children & {
    roles: UserRoles | UserRoles[];
    redirect?: Routes;
  };

const RolesRedirects = {
  [UserRoles.AgencyManager]: Routes.Analytics,
  [UserRoles.Recruiter]: Routes.Analytics,
  [UserRoles.Contractor]: Routes.Profile,
  [UserRoles.TrainingProvider]: Routes.Profile,
  [UserRoles.Admin]: Routes.AdminDashboard,
};

const RoleGuard: FC<Props> = ({
  user: { role },
  roles,
  redirect = RolesRedirects[role],
  children,
}) => {
  if (Array.isArray(roles) ? !roles.includes(role) : roles !== role) {
    return <Navigate to={redirect} replace />;
  }

  return children;
};

export default withMe(RoleGuard);
